import type { WebContainer } from '@webcontainer/api';
import { BOLT_CONFIG_JSON, type BoltConfigJson } from '~/lib/persistence/frameworks';
import { workbenchStore } from '~/lib/stores/workbench';
import { getOutputAsString } from '~/lib/utils/webcontainer';
import { getBuildConfig } from '~/templates';

export async function resolveBuildConfig(webcontainer: WebContainer) {
  let config: BoltConfigJson | undefined;
  let buildConfig: BoltConfigJson['build'] | undefined;

  try {
    config = JSON.parse(await webcontainer.fs.readFile(BOLT_CONFIG_JSON, 'utf8')) as BoltConfigJson;
  } catch {
    // do nothing if the file does not exist, or we can't parse the file
  }

  if (config?.build) {
    // if the `.bolt/config.json` has a build configuration, use that
    buildConfig = config.build;
  }

  const framework = workbenchStore.framework.get();

  if (framework?.build) {
    buildConfig = {
      command: framework.build.command('npm'),
      output: framework.build.output,
    };
  }

  if (config?.template) {
    // if we don't have a build config based on the framework, check if we have on based on the template
    const templateBuildConfig = getBuildConfig(config.template);

    if (templateBuildConfig) {
      buildConfig = templateBuildConfig;
    }
  }

  try {
    const { default: script } = await import('vite-config-extractor?raw');
    const process = await webcontainer.spawn('node', ['-e', script]);

    const output = await getOutputAsString(process);
    const outDir = output.trim();

    if (outDir && buildConfig) {
      buildConfig = { ...buildConfig, output: outDir };
    }
  } catch {}

  return buildConfig;
}
